import { IoArrowBack } from 'react-icons/io5'; // ou de 'react-icons/fa' (FaArrowLeft)

const Header = ({ title, icon: Icon, onBack }) => {
  return (
    <div style={styles.header}>
      <div style={styles.headerContent}>
        {onBack && (
          <button
            onClick={onBack}
            style={styles.backButton}
            aria-label="Voltar"
          >
            <IoArrowBack />
          </button>
        )}
        <div style={styles.titleContainer}>
          <h1 style={styles.titulo}>
            {Icon && <Icon style={styles.icon} />}
            {title}
          </h1>
        </div>
      </div>
    </div>
  );
};

const styles = {
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '16px 20px',
    background: 'rgb(220, 225, 247)',
    color: '#fff',
    fontFamily: 'Montserrat, sans-serif',
    width: '100%',
    // marginBottom: '24px',
  },
  headerContent: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    maxWidth: '1200px',
  },
  backButton: {
    position: 'absolute',
    left: '0px',
    top: '50%',
    transform: 'translateY(-50%)',
    fontFamily: 'Montserrat, sans-serif',
    // background: 'rgba(9, 68, 140, 0.08)', // fundo suave (opcional)
    border: 'none',
    cursor: 'pointer',
    fontSize: '28px', // controla o tamanho do ícone
    color: '#09448C',
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background-color 0.2s ease, transform 0.1s ease',
    zIndex: 10,
    lineHeight: 1,
    padding: 0,
  },
  // Para o efeito hover, recomendo usar CSS Modules ou styled-components.
  // Exemplo de regra CSS (caso use CSS Modules):
  // .backButton:hover { background-color: rgba(9, 68, 140, 0.15); transform: translateY(-50%) scale(1.05); }
  titleContainer: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    paddingLeft: '2px',
    paddingRight: '2px',
  },
  titulo: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '15px',
    fontSize: '1.1em',
    margin: 0,
    color: '#09448C',
    fontWeight: '600',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  icon: {
    color: '#09448C',
    fontSize: '24px',
  },
};

export default Header;